import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router';
import GroupDialog from './detail/GroupDialog';
import { useContext, useEffect, useState } from 'react';
import { ClassificationContext } from '../context/ClassificationContext.types';
import { AssignObjectDialog } from './detail/AssignObjectDialog';

export enum DialogState {
  Closed,
  Edit,
  Add,
}

export function GroupPage() {
  const { t } = useTranslation();

  const [dialogState, setDialogState] = useState(DialogState.Closed);
  const [isAssignDialogOpen, setIsAssignDialogOpen] = useState(false);

  const { id } = useParams();

  const { setSelectedGroupId, selectedGroup } = useContext(ClassificationContext);

  useEffect(() => {
    if (id) setSelectedGroupId(id);
    else setSelectedGroupId(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Stack>
      <GroupDialog
        isOpen={dialogState !== DialogState.Closed}
        group={dialogState === DialogState.Edit ? selectedGroup : null}
        onClose={() => setDialogState(DialogState.Closed)}
      />

      <AssignObjectDialog
        isOpen={isAssignDialogOpen}
        group={selectedGroup}
        onClose={() => setIsAssignDialogOpen(false)}
      />
      <Stack
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          mb: 3,
          alignItems: 'center',
        }}
      >
        <Typography variant="h1">
          {selectedGroup
            ? t('classification.groups.title', { name: selectedGroup.name })
            : t('classification.groups.plural')}
        </Typography>
        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
          }}
        >
          {selectedGroup && (
            <>
              <Button variant="contained" onClick={() => setIsAssignDialogOpen(true)}>
                {t('classification.groups.assignObject')}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setDialogState(DialogState.Edit)}
              >
                {t('classification.groups.editGroup')}
              </Button>
            </>
          )}
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setDialogState(DialogState.Add)}
          >
            {t('classification.groups.addGroup')}
          </Button>
        </Stack>
      </Stack>
      <Stack>
        <Outlet />
      </Stack>
    </Stack>
  );
}
